@if (mapLoading()) {
  <mat-progress-bar
    class="map-facilities-loading"
    color="primary"
    mode="indeterminate"
    style="margin: 1rem 0; width: 100%"></mat-progress-bar>
} @else {
  @if (selectedArea()) {
    <div class="map-preview-container">
      @if (mapsLoader.apiLoaded$ | async) {
        <div class="map-container">
          <google-map
            *mapThemeReload
            id="map"
            mapId="map"
            [options]="mapOptions"
            [center]="center() ? { lat: center()!.lat, lng: center()!.lng } : undefined"
            height="400px"
            width="100%"
            (mapInitialized)="onMapInitialized($event)"
            (mapClick)="onMapClick($event)"
            (error)="onMapError($event)">
            <!-- Markers are now managed by MarkerClusterer in TypeScript -->
            <!-- Info Window -->
            <map-info-window #infoWindow>
              @if (selectedMarker) {
                <div class="info-window">
                  <div class="info-window-title">{{ selectedMarker.title }}</div>
                  <div class="info-window-subtitle">{{ selectedMarker.subtitle }}</div>
                </div>
              }
            </map-info-window>
          </google-map>
        </div>
      } @else {
        <div class="loading-container">
          <mat-spinner></mat-spinner>
        </div>
      }
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%">
        <app-filtered-search
          [hideSearch]="true"
          [fields]="filterFields"
          [defaultFilters]="defaultFilters.get(selectedArea().id)"
          [constrainFilterMenu]="true"
          (filtersChange)="onFilterChange($event)"
          display="inline"
          type="chip">
        </app-filtered-search>
        <div>{{ facilities().length }} facilities</div>
        <div class="map-preview-footer">
          <div>
            <button
              [disabled]="previewPage().data.length === 0"
              mat-button
              id="map-preview-facilities-button"
              (click)="onPreviewMapFacilities()">
              <mat-icon>{{ previewPage().show ? 'visibility_off' : 'visibility' }}</mat-icon>
              {{
                previewPage().show
                  ? ('Hide Preview' | translate: locale.language)
                  : ('Show Preview' | translate: locale.language)
              }}
            </button>
            <button mat-button color="warn" id="remove-map-facilities-button" (click)="onRemoveMap()">
              <mat-icon>cancel</mat-icon>
              {{ 'Remove' | translate: locale.language }}
            </button>

            <button
              mat-button
              color="primary"
              id="edit-map-facilities-button"
              (click)="onLaunchMap(selectedMap.context)"
              matTooltip="Warning: Changing the map will reset currently selected facilities.">
              <mat-icon>edit</mat-icon>
              {{ 'Edit Map' | translate: locale.language }}
            </button>
          </div>
        </div>
      </div>
      <div class="map-preview-facilities-container">
        @if (previewPage().show) {
          <div class="map-preview-facilities-table-container">
            <table class="map-preview-facilities-table" mat-table [dataSource]="previewPage().data">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="name-column">Name</th>
                <td mat-cell *matCellDef="let element" class="name-column">{{ element.name }}</td>
              </ng-container>
              <ng-container matColumnDef="locationType">
                <th mat-header-cell *matHeaderCellDef class="type-column">Location Type</th>
                <td mat-cell *matCellDef="let element" class="type-column">{{ element.locationType }}</td>
              </ng-container>
              <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef class="type-column">Address</th>
                <td mat-cell *matCellDef="let element" class="type-column">{{ toAddress(element) }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['name', 'locationType', 'address']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['name', 'locationType', 'address']"></tr>
            </table>
          </div>
          <mat-paginator
            [pageSizeOptions]="[10, 25, 50, 100]"
            [showFirstLastButtons]="true"
            [pageSize]="previewPage().pageSize"
            [pageIndex]="previewPage().page - 1"
            (page)="pagePreview($event)"
            [length]="previewPage().totalCount"></mat-paginator>
        }
      </div>

      @if (mapFacilitiesLoading()) {
        <mat-progress-bar
          class="map-facilities-loading"
          color="primary"
          mode="indeterminate"
          style="margin: 1rem 0; width: 100%"></mat-progress-bar>
      }
    </div>
  }
}
@if (!selectedArea() || mapError()) {
  <div class="select-map-buttons-container">
    <mat-icon class="message-icon">info</mat-icon>
    <p>No area selected. Please define an area on the map.</p>
    <button
      mat-raised-button
      color="primary"
      [disabled]="mapLoading()"
      (click)="onLaunchMap()"
      id="map-facilities-button">
      <mat-icon>map</mat-icon>
      {{ 'Select Area on Map' | translate: locale.language }}
    </button>
  </div>
}
